import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useIsAuthenticated } from '@azure/msal-react';
import { DEV_AUTH_BYPASS } from '../auth/devAuth';

/** MSAL's redirect landing route. The redirect promise is handled in main.tsx before render,
 *  so by the time this mounts we only need to forward the user on. */
export function AuthRedirectPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (DEV_AUTH_BYPASS || isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ height: '70vh' }}>
      <Box component="img" src="/brand/aiqbee-square.png" alt="" sx={{ width: 64, height: 64 }} />
      <CircularProgress size={24} />
      <Typography variant="body2" color="text.secondary">{t('auth.signingIn')}</Typography>
    </Stack>
  );
}
